import { MeasureCard } from '../../components/viz/MeasureCard';
import { DashboardLayout } from './DashboardLayout';

export function TrainersDashboard() {
  return (
    <DashboardLayout
      title="Trainers"
      intro="Activity for staff in the Trainer group, resolved via the staff registry. Cards populate once the aXcelerate connector starts syncing enrolment and instance data."
    >
      <MeasureCard
        title="Completions — 90 days"
        description="Status = C, outcome = 20."
        spec={{ measure: 'enrolments.completions_last_90d' }}
        viz="kpi"
      />
      <MeasureCard
        title="Completions by trainer"
        description="Top 15 trainers by completed enrolments. Unattributed completions surface here too."
        spec={{ measure: 'enrolments.by_trainer' }}
        viz="bar"
      />
      <MeasureCard
        title="Enrolments by status"
        description="All enrolments in the system, grouped by status code."
        spec={{ measure: 'enrolments.by_status' }}
        viz="bar"
      />
    </DashboardLayout>
  );
}
